import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


function Blog() {
    const [eventList, SetEvent] = useState([]);
    const [newsList, SetNews] = useState([]);

    const urlImg = "https://dev.jftheskinspecialist.com/images/news/";

    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/event')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetEvent(datas.data);
        });

        fetch('https://dev.jftheskinspecialist.com/api/news')
        .then((res) => {
            return res.json();
        })
        .then((datas) => {
            console.log(datas.data);
            SetNews(datas.data);
        });
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <div className="p-4 bg-[#fefaed]">
            <section class="dark:text-gray-800">
                
                <div class="container max-w-6xl p-6 mx-auto space-y-6 sm:space-y-12">
                    <div class="mb-6 text-left">
                        <h3 class="font-bold text-left" style={{ fontFamily: 'avenir_next_lt_pro_heavy_condensed_italic', fontSize: 32 }}>
                            <span class="text-[#ff8e35] drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
                                {getLang === 'id' ? 'BERITA' : 'NEWS'}
                            </span>
                        </h3>
                        {/*<p class="text-left mt-4 font-medium text-slate-500">OUR NEWS</p>*/}
                    </div>

                    {/*{topNews.map((newstop, indextop) => (
                        <div key={indextop}>
                            <a rel="noopener noreferrer" href="#" class="block max-w-sm gap-3 mx-auto sm:max-w-full group hover:no-underline focus:no-underline lg:grid lg:grid-cols-12 dark:bg-gray-50">
                                <img src={urlImg + '' + newstop.featured_image} alt="" class="object-cover w-full h-64 rounded sm:h-96 lg:col-span-7 dark:bg-gray-500" />
                                <div class="p-6 space-y-2 lg:col-span-5">
                                    <h3 class="text-2xl font-semibold sm:text-4xl group-hover:underline group-focus:underline">
                                        {newstop.name}
                                    </h3>
                                    <span class="text-xs dark:text-gray-600">{newstop.created_at}</span>
                                    <p>
                                        <div dangerouslySetInnerHTML={{ __html: newstop.intro }}></div>
                                    </p>
                                </div>
                            </a>
                        </div>
                    ))}*/}

                    <div class="grid justify-center grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {newsList.map((data_news, indexnews_list) => (
                            <div className='max-w-sm rounded overflow-hidden shadow-lg' key={indexnews_list} style={{ fontFamily: 'MuseoSansRounded200', fontSize: 14 }}>
                                <Link to={`/detailblog/${data_news.id}`} class="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-50">
                                    <img role="presentation" class="object-cover w-full rounded h-44 dark:bg-gray-500" src={urlImg + '' + data_news.featured_image} alt="" />
                                    <div class="p-6 space-y-2">
                                        
                                        {getLang === 'id' ?
                                            <h3 style={{ fontFamily: 'MuseoSansRounded900', fontSize: 16 }}>{data_news.name}</h3>
                                                :
                                            <h3 style={{ fontFamily: 'MuseoSansRounded900', fontSize: 16 }}>{data_news.name_en}</h3>
                                        }
                                        <span class="text-xs dark:text-gray-600">{data_news.created_at}</span>
                                        <p style={{ textAlign: 'justify' }}>
                                            {getLang === 'id' ?
                                                <div dangerouslySetInnerHTML={{ __html: data_news.intro }}></div>
                                                :
                                                <div dangerouslySetInnerHTML={{ __html: data_news.intro_en }}></div>
                                            }
                                        </p>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                    
                </div>
            </section>

            <section class="dark:text-gray-800">

                <div class="container max-w-6xl p-6 mx-auto space-y-6 sm:space-y-12">
                    <div class="mb-6 text-left">
                        <h3 class="font-bold text-left" style={{ fontFamily: 'avenir_next_lt_pro_heavy_condensed_italic', fontSize: 32 }}>
                            <span class="text-[#ff8e35] drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
                                {getLang === 'id' ? 'INFO' : 'EVENT'}
                            </span>
                        </h3>
                        {/*<p class="text-left mt-4 font-medium text-slate-500">OUR EVENT</p>*/}
                    </div>

                    {/*{topNews.map((newstop, indextop) => (
                        <div key={indextop}>
                            <a rel="noopener noreferrer" href="#" class="block max-w-sm gap-3 mx-auto sm:max-w-full group hover:no-underline focus:no-underline lg:grid lg:grid-cols-12 dark:bg-gray-50">
                                <img src={urlImg + '' + newstop.featured_image} alt="" class="object-cover w-full h-64 rounded sm:h-96 lg:col-span-7 dark:bg-gray-500" />
                                <div class="p-6 space-y-2 lg:col-span-5">
                                    <h3 class="text-2xl font-semibold sm:text-4xl group-hover:underline group-focus:underline">
                                        {newstop.name}
                                    </h3>
                                    <span class="text-xs dark:text-gray-600">{newstop.created_at}</span>
                                    <p>
                                        <div dangerouslySetInnerHTML={{ __html: newstop.intro }}></div>
                                    </p>
                                </div>
                            </a>
                        </div>
                    ))}*/}

                    <div class="grid justify-center grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {eventList.map((data_event, indexevent_list) => (
                            <div className='max-w-sm rounded overflow-hidden shadow-lg' key={indexevent_list} style={{ fontFamily: 'MuseoSansRounded200', fontSize: 14 }}>
                                <Link to={`/detailblog/${data_event.id}`} class="max-w-sm mx-auto group hover:no-underline focus:no-underline dark:bg-gray-50">
                                    <img role="presentation" class="object-cover w-full rounded h-44 dark:bg-gray-500" src={urlImg + '' + data_event.featured_image} alt="" />
                                    <div class="p-6 space-y-2">
                                        {getLang === 'id' ?
                                            <h3 style={{ fontFamily: 'MuseoSansRounded900', fontSize: 16 }}>{data_event.name}</h3>
                                            :
                                            <h3 style={{ fontFamily: 'MuseoSansRounded900', fontSize: 16 }}>{data_event.name_en}</h3>
                                        }
                                        <span class="text-xs dark:text-gray-600">{data_event.created_at}</span>
                                        <p style={{ textAlign: 'justify' }}>
                                            {getLang === 'id' ?
                                                <div dangerouslySetInnerHTML={{ __html: data_event.intro }}></div>
                                                :
                                                <div dangerouslySetInnerHTML={{ __html: data_event.intro_en }}></div>
                                            }
                                        </p>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>

                </div>
            </section>
        </div>
    );
}

export default Blog;
